import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Fonts_Google = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🌐 CSS Google Fonts</h1>

      {/* Intro */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ What are Google Fonts?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Google Fonts is a free library of open-source fonts you can easily
          integrate into your website. It allows you to use stylish fonts
          without hosting them locally.
        </p>
      </div>

      {/* How to Use */}
      <div className="tutorial-section">
        <h2 className="section-title">📖 How to Use Google Fonts</h2>
        <p>You can add Google Fonts to your project in two ways:</p>
        <ul className="tutorial-list">
          <li>
            <strong>Using &lt;link&gt; in HTML</strong> – Add a link tag inside
            the <code>&lt;head&gt;</code>.
          </li>
          <li>
            <strong>Using @import in CSS</strong> – Import fonts directly in
            your CSS file.
          </li>
        </ul>
      </div>

      {/* Code Examples */}
      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Example 1: Using Link</h2>
        <CodeCopyBlock
          code={`<!-- Inside your HTML head -->
<link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">

<style>
  body {
    font-family: 'Roboto', sans-serif;
  }
</style>`}
        />

        <p style={{ fontFamily: "'Roboto', sans-serif" }}>
          This text is styled with <strong>Roboto</strong> from Google Fonts.
        </p>
      </div>

      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Example 2: Using @import</h2>
        <CodeCopyBlock
          code={`/* Inside your CSS file */
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

p {
  font-family: 'Open Sans', sans-serif;
}`}
        />

        <p style={{ fontFamily: "'Open Sans', sans-serif" }}>
          This text is styled with <strong>Open Sans</strong> using @import.
        </p>
      </div>

      {/* Best Practices */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 Best Practices</h2>
        <ul className="tutorial-list">
          <li>
            Always include a fallback font (e.g., <code>sans-serif</code>).
          </li>
          <li>
            Only load the font weights and styles you need to improve
            performance.
          </li>
          <li>
            Use <code>display=swap</code> to prevent blank text while fonts
            load.
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          After learning about Google Fonts, check out{" "}
          <a href="/css/font-style" className="learn-more">
            CSS Font Style
          </a>{" "}
          and{" "}
          <a href="/css/font-weight" className="learn-more">
            CSS Font Weight
          </a>{" "}
          to control how your fonts look in detail.
        </p>
      </div>
    </div>
  );
};

export default Fonts_Google;
